<div class="featured portfolio-items properties-list list-view" *ngIf="properties && properties.length>0">
  <div *ngFor="let property of properties; let i = index;" class="row property-area">
    <div class="item col-6 col-lg-5 col-md-12 col-xs-12 landscapes h-100 sale p-0">
      <div class="project-single mb-0 bb-0">
        <a (click)="loadingService.setLoading(true)"
          [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
          <div class="project-inner project-head">
            <div class="homes">
              <!-- homes img -->
              <a (click)="loadingService.setLoading(true)"
                [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
                class="homes-img">
                <div *ngIf="property.highlight" class="homes-tag button alt featured">{{'t-highlight' |
                  translate}}</div>
                <div *ngIf="property?.cardToShow" class="homes-tag button alt sale">
                  {{property?.cardToShow}}</div>
                <!-- <img [src]="dirPropertyImg + property.media" alt="list-1" class="img-responsive"> -->
                <img [src]="property.media[0].file" alt="Property Image" class="img-responsive fit-cover">
                <div class="property-distance text-start w-100">
                  <span class="ms-2"
                    *ngIf="property?.distance && property?.distance >= 0">{{getDistance(property?.distance)}}</span>
                </div>
              </a>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-lg-7 col-6 col-md-12 homes-content pb-0 position-relative">
      <!-- homes address -->
      <div class="property-data">
        <a
          [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
          <a (click)="loadingService.setLoading(true)"
            [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
            <h3 class="property-title">{{property.title}}</h3>
          </a>
          <p *ngIf="property.district && property.district != ''" class="homes-address mb-3">
            <a (click)="loadingService.setLoading(true)"
              [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
              <i class="fa fa-map-marker"></i><span
                *ngIf="property.county && property.county != ''">{{property.county}},
              </span><span>{{property.district}}</span>
            </a>
          </p>
          <p *ngIf="(!property.district || property.district == '') && property?.region" class="homes-address mb-3">
            <a (click)="loadingService.setLoading(true)"
              [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
              <i class="fa fa-map-marker"></i><span
                *ngIf="property.country && property.country != ''">{{property.country}},
              </span><span>{{property?.region}}</span>
            </a>
          </p>
          <p class="preview-description mt-2">
            <a (click)="loadingService.setLoading(true)"
              [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
              <span [innerHTML]="property.description"></span>
            </a>
          </p>
          <!-- homes List -->
          <ul class="homes-list clearfix pb-3 row">
            <ng-container *ngFor="let division of property.divisions">
              <li *ngIf="division.tag == 'Bedrooms' && division.value != 0" class="the-icons col-4">
                <i class="flaticon-bed mr-2" aria-hidden="true"></i>
                <span>{{division.value}} {{'t-beds' | translate}}</span>
              </li>
              <li *ngIf="division.tag == 'Bathrooms' && division.value != 0" class="the-icons col-4">
                <i class="flaticon-bathtub mr-2" aria-hidden="true"></i>
                <span>{{division.value}} {{'t-baths' | translate}}</span>
              </li>
              <li *ngIf="division.tag == 'Kitchens' && division.value != 0" class="the-icons col-4">
                <i class="mdi mdi-stove mr-2" aria-hidden="true"></i>
                <span>{{division.value}} {{'t-kitchens' | translate}}</span>
              </li>
            </ng-container>
          </ul>
        </a>
        <!-- Price -->
        <div class="price-properties">
          <h3 class="title mt-3">
            <a (click)="loadingService.setLoading(true)"
              [ngClass]="{'price-on-request': !property?.price || property?.price == 0 }"
              [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.price
              != 0 && property.price !=
              null ? priceFormat(property.price, property.currency) : 't-on-request' | translate}}</a>
          </h3>
          <div class="compare d-flex align-items-center">
            <a (click)="utilsPropertiesService.shareProperty(property)" href=" javascript:void(0)" class="me-3">
              <i class="fas fa-share-alt"></i>
            </a>
            <a (click)="savedService.saveProperty(property.uniqueId)">
              <ion-icon *ngIf="!savedService.isSavedProperty(property.uniqueId)" class="fs-4"
                src="assets/new-icons/heart-outline.svg"></ion-icon>
              <ion-icon *ngIf="savedService.isSavedProperty(property.uniqueId)"
                class="fs-4 heart-icon colored-heart-icon" src="assets/new-icons/heart.svg"></ion-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
